/* eslint-disable max-len */
import * as Sentry from '@sentry/react';

import {
  SURVEY_PROJECT_VALUES,
  SURVEY_RESET_QUESTIONS,
  SURVEY_TEST_SESSION,
  SURVEY_QUESTIONS,
  SURVEY_PAGE_QUESTIONS_ANSWERS,
  NEXT_SURVEY_PAGE_QUESTIONS,
  SURVEY_ERROR,
} from '../actions/action-types';

export const initialState = {
  currentSurveyPage: {},
  error: null,
  isLastSurveyPage: false,
  isPreview: false,
  loading: false,
  project: {},
  testSession: {},
  maxSurveyPages: 1,
  surveyPagesAnswers: [],
};

const survey = (state = initialState, action) => {
  Sentry.setTag('redux.action', action.type);

  switch (action.type) {
    case SURVEY_PROJECT_VALUES: {
      return {
        ...state,
        project: action.payload.project,
      };
    }

    case SURVEY_RESET_QUESTIONS: {
      return {
        ...initialState,
        project: state.project,
        testSession: {
          ...state.testSession,
        },
      };
    }

    case SURVEY_TEST_SESSION: {
      const { id } = action.payload.testSession;

      return {
        ...state,
        testSession: { id },
      };
    }

    case SURVEY_QUESTIONS: {
      return {
        ...state,
        currentSurveyPage: action.payload.currentSurveyPage,
        questions: action.payload.questions,
        surveyPages: action.payload.surveyPages,
        isLastSurveyPage: action.payload.surveyPages.length === 1,
        maxSurveyPages: action.payload.maxSurveyPages,
      };
    }

    case SURVEY_PAGE_QUESTIONS_ANSWERS: {
      const { answers } = action.payload;

      return {
        ...state,
        surveyPagesAnswers: [...state.surveyPagesAnswers, answers],
      };
    }

    case NEXT_SURVEY_PAGE_QUESTIONS: {
      const {
        currentSurveyPage,
        isLastSurveyPage,
      } = action.payload;

      return {
        ...state,
        currentSurveyPage,
        isLastSurveyPage,
      };
    }

    case SURVEY_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default survey;
